import User from 'domain/user';

class CoiExpPermissions {
  canEdit = (user, project) => !User.isPrimary(user, project);
}

export default new CoiExpPermissions();
